var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.5h-1.187C15.568 4.5 12.74 3.257 10.5 1 8.259 3.257 5.432 4.5 2.188 4.5H1v3.694C1 14.836 5.037 20.417 10.5 22c5.463-1.582 9.5-7.164 9.5-13.806V4.5z",
    fill: "#499B92",
    stroke: "#499B92",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.935 10.41h.305c.503 0 .913.398.913.89v4.156c0 .491-.41.89-.913.89H7.76a.903.903 0 0 1-.914-.89V11.3c0-.492.41-.89.913-.89h.305V9.221c0-1.31 1.092-2.375 2.435-2.375 1.344 0 2.436 1.065 2.436 2.375v1.187zM10.5 7.638c-.895 0-1.624.71-1.624 1.583v1.188h3.248V9.221c0-.873-.728-1.583-1.624-1.583z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 12.692,
    r: 0.731,
    fill: "#499B92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#499B92",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    d: "M10.5 12.942v1.693"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.b714db427c5c745e1b03669d61c11530.svg";
export { ForwardRef as ReactComponent };